"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        paddingTop: 1,
        paddingBottom: 1,
        maxHeight: 'inherit',
        '&[data-is-invisible=true]': {
            visibility: 'hidden'
        }
    },
    menu: {
        listStyle: 'none',
        paddingLeft: 0,
        backgroundColor: theme.grey9,
        borderRadius: 2,
        boxShadow: `inset 0 0 0 1px ${theme.grey5}, 2px 3px 10px 0 rgba(0,0,0,0.1)`,
        overflow: 'auto',
        outline: 'none',
        maxHeight: 'inherit'
    }
});
//# sourceMappingURL=pulldown.menu.style.js.map